import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const UserList = () => {
  const columns = [
    { label: 'Username',   value: 'username' },
    { label: 'Email',      value: 'email' },
    { label: 'First Name', value: 'first_name' },
    { label: 'Last Name',  value: 'last_name' },
    { label: 'Role',       value: (item) => item.role || '—' },
    { label: 'Company',    value: (item) => item.company_name || '—' },
    { label: 'Tenant ID',  value: (item) => item.tenant_id || '—' },
  ];

  return (
    <div>
      <h1>User Management</h1>
      <ListTemplate
        columns={columns}
        fetchUrl={API_DOMAIN + API_ROUTES['securityUsers']}
      />
    </div>
  );
};

export default UserList;
